module.exports = __webpack_public_path__ + "img/2_127.60e839ff.png";